import instance from './DefaultApi';

export default class DeMappingService {
    ControllerName = 'DeMapping';

    // create de map data
    CreateDemapping(demap) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateDemapping`, demap).then(res => res)
    }   
}